/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-deletenew': {
    width: 20,
    height: 22,
    viewBox: '0 0 20 22',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M7.25.917h5.5c1.013 0 1.833.82 1.833 1.833v.917h2.75c1.013 0 1.834.82 1.834 1.833v1.833c0 1.013-.821 1.833-1.834 1.833h-.073l-.843 10.084c0 1.012-.821 1.833-1.834 1.833H5.417c-1.013 0-1.834-.82-1.83-1.757L2.74 9.166h-.073A1.833 1.833 0 01.833 7.333V5.5c0-1.013.821-1.833 1.834-1.833h2.75V2.75c0-1.013.82-1.833 1.833-1.833zM2.667 5.5h14.666v1.833H2.667V5.5zm1.912 3.666h10.842l-.835 10.008-.003.076H5.417L4.579 9.166zM12.75 2.75v.917h-5.5V2.75h5.5z" _fill="#566473"/>'
  }
})
